import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 0524FF60-B273-4675-9B69-043730244645
 * name folder-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderOutlineIcon = createSvgIcon(<><path d="M20,18H4V8H20M20,6H12L10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6Z" /></>, 'FolderOutlineIcon');
export default FolderOutlineIcon